<template>
  <list listTitle="Checkout de anúncios" :listLogo="moduleDefinition.logo" filterTitle="Filtros" :sortFields="sortFields" :sortDefault="{ field: sortFields[0], order: 'asc' }" :loading="loading" :total="announcements.total" @change="onChange">
    <template slot="filters">
      <form-group label="Conta">
        <select v-model="selectedAccount" class="form-select">
          <option :value=null>{{ $t('choose.label') }}</option>
          <option v-for="account in mercadoLivreAccounts" :value="account.identifier">{{ `${account.name} (${account.nickname})` }}</option>
        </select>
      </form-group>
    </template>

    <div class="l-col-12@md" v-if="announcements.items && selectedAccount">
      <announcement-match-card v-for="announcement in announcements.items.identifiers" :key="announcement" :announcement="announcement" :account="selectedAccount"/>
    </div>
    <div class="l-col-12@md u-textCenter" v-else>
      <panel>Nenhum anúncio encontrado.</panel>
    </div>
  </list>
</template>

<script>
  import api from '@/api'
  import notifier from '@/notifier'
  import { mapActions, mapGetters } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { merge } from 'lodash'
  import List from '@/components/shared/list/Paginator'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import AnnouncementMatchCard from '@/components/marketplace/mercadoLivre/AnnouncementMatchCard'

  export default {
    inject: ['expeditersDI'],
    data: () => ({
      sortFields: [
        'title'
      ],
      announcements: [],
      loading: false,
      selectedAccount: null,
      options: {}
    }),
    mounted () {
      this.fetchAccounts({})
        .then(() => {
          if (this.mercadoLivreAccounts.length === 1) {
            this.selectedAccount = this.mercadoLivreAccounts[0].identifier
          }
          this.loading = false
        })
    },
    methods: {
      ...mapActions('mercadoLivreAccounts', [
        'fetchAccounts'
      ]),
      async onChange (options) {
        if (this.options.account === null || !this.selectedAccount) {
          return false
        }

        this.loading = true

        if (options === undefined) {
          options = this.$children[0].options
        }

        merge(this.options, options)
        try {
          this.announcements = await api.mercadoLivre.getAnnouncementCatalog(this.options, this.selectedAccount)
        } catch (e) {
          notifier.error('Erro ao buscar os anúncios disponíveis para o catálago.', 'Erro')
        } finally {
          this.loading = false
        }
      }
    },
    computed: {
      ...mapFields({
        mercadoLivreAccounts: 'mercadoLivreAccounts.accounts'
      }),
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType',
        'definitionModulesInstalled'
      ]),
      moduleDefinition () {
        return this.getDefinitionModuleByIdentifierAndType('marketplace', 'mercadoLivre')
      }
    },
    watch: {
    },
    components: {
      List,
      Panel,
      FormGroup,
      AnnouncementMatchCard
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// List.vue?3f6a2ca8